export default "__VITE_ASSET__45409549__"